import React, { Component, Fragment, useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import WebConnect from "./connect"

import logo from './logo.png';
import './App.css';

class App extends Component {

  constructor(props){
    super()

    this.state = {
      amountMinted: 'Please connect wallet',
      amountToMint: 0,
      mintPrice: 0.05,
      connected: 'Connect',
      mintText: 'Mint (connect)'
    }


    const interval = setInterval(() => {
      if (WebConnect.state.web3 != null){
        this.setState({
          amountMinted: WebConnect.state.totalMinted + ' (out of 7777)',
          mintText: 'Mint'
        })
      }
    }, 1000);
  }


  minMax(value){
    if(parseInt(value) < 0 || isNaN(parseInt(value)))
        return 0;
    else if(parseInt(value) > 10)
        return 10;
    else return value;
  }

  setAmountToBuy(val){
    this.setState({amountToMint: val})
  }

  async purchaseNFTs () {
    if(WebConnect.state.web3)
      await WebConnect.mint(this.state.amountToMint)
  }


  render() {
    return (
      <div className="App">
        <div className="connect">
          <Button disabled={this.state.web3 != null} className="connectbutton" onClick={async () => {
            await WebConnect.onWeb3Connect('injected')
            this.setState({connected: WebConnect.getAddress()})
          }}>{this.state.connected}</Button>
        </div>
        <div className="App-header">
        <h2>Gnarly Beach Board Shop Mint</h2>
        <div/>
        <img src={logo} className="App-logo" alt="logo" />
        </div>
        <br /><br />
        <h4>Total minted: {this.state.amountMinted}</h4>
        <br /><br />

        <h6>Amount to mint (10 max per transaction)</h6>
        <input style={{marginTop: '10px'}} type="number" value={this.state.amountToMint} onChange={(e) => this.setAmountToBuy(this.minMax(e.target.value))} />
        <br /><br />
        <Button disabled={this.state.mintText == 'Mint (connect)'}className="connectbutton" onClick={() => {
          this.purchaseNFTs()
        }}>{this.state.mintText}</Button>
      </div>
    );
  }
}

export default App;
